import { IDotXetHocVuPhamVi } from "../../model/response/xet-hoc-vu/IDotXetHocVuPhamVi";
import { apiClient } from "../apiClient";
import { DOT_XET_HOC_VU_ENDPOINT } from "./dotXetHocVuApi";

const DOT_XET_HOC_VU_PHAM_VI_ENDPOINT = "dot-xet-hoc-vu-pham-vi";
export const dotXetHocVuPhamViApi = {
    SelectByDotXetHocVuId: (id: number) => apiClient.get(`${DOT_XET_HOC_VU_ENDPOINT}/${id}/pham-vi`),
    Insert: (data: IDotXetHocVuPhamVi) => apiClient.post(`${DOT_XET_HOC_VU_PHAM_VI_ENDPOINT}`, data),
    Delete: (id: number) => apiClient.delete(`${DOT_XET_HOC_VU_PHAM_VI_ENDPOINT}/${id}`),
}